$(document).ready(function(){
// $('.announcement_slider').slick({
//   dots: false,
//   infinite: true,
//   speed: 300,
//   arrows: true,
//   slidesToShow: 1,
//   slidesToScroll: 1
// });
  $('.Collections_main .products-showcase-item-flavor .wrapper_inner').slick({
  dots: false,
  infinite: true,
  speed: 300,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1
});
                  
// $(document).on('click','.load-more_faq',function(){
//   $(this).hide();
//   $('.accordion-container').show();
// });	
$(document).on('click','.coltab',function(){
  $('.coltab, .homepage-product-grid-wrapper').removeClass('active');
  $(this).addClass('active');
  var clickedTab = $(this).attr('data-tab');
  $('.homepage-product-grid-wrapper[data-tab-linked="'+ clickedTab +'"]').addClass('active');
});

  
   $('.enable_blog-slider').slick({
  arrows: true,
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  $('.collection_slider').slick({
  arrows: true,
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
});
// infused popcorn variant tab 
$(document).ready(function() {
  // Remove 'active' class from all labels
  $('.productpage-right-size-tabs label').removeClass('active');

  // Add 'active' to the first label and check its radio input
  const firstLabel = $('.productpage-right-size-tabs label').first();
  firstLabel.addClass('active');
  firstLabel.find('input[type="radio"]').prop('checked', true).trigger('change');
});